module.exports = __webpack_public_path__ + "img/banner-about.4deeff77.jpg";